const toNum = (v) => {
  const n = parseFloat(v);
  return Number.isFinite(n) ? n : 0;
};

export const computePlanFinalCost = (plan, options = {}) => {
  if (!plan) return '';
  const { is_wa = false, is_backup = false } = options;
  const base = toNum(plan.cost);
  const wa = is_wa ? toNum(plan.wa_cost) : 0;
  const backup = is_backup ? toNum(plan.backup_cost) : 0;
  const subtotal = base + wa + backup;

  const perc = toNum(plan.discount_perc);
  const flat = toNum(plan.discount_cost);

  let discount = 0;
  if (perc > 0) {
    discount = subtotal * (perc / 100);
  } else if (flat > 0) {
    discount = flat;
  }

  return Math.max(0, subtotal - discount).toFixed(2);
};

export const formatDuration = (days, lang = 'ar') => {
  const d = Number(days) || 0;
  if (lang === 'ar') {
    if (d === 30) return 'شهر واحد';
    if (d === 90) return '3 أشهر';
    if (d === 180) return '6 أشهر';
    if (d === 365) return 'سنة';
    return `${d} يوم`;
  }
  if (d === 30) return '1 month';
  if (d === 90) return '3 months';
  if (d === 180) return '6 months';
  if (d === 365) return '1 year';
  return `${d} days`;
};
